import { DEFAULT_LANG } from "./constants"


export const localize = ({language, en, fr }) => {
  const langPrefix = (language === DEFAULT_LANG || !language) ? '' : '/fr'
  return langPrefix === "/fr"
    ? fr
    : en
}